(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('ReligiousInstitutionController', ReligiousInstitutionController);
	
	ReligiousInstitutionController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','ReligiousInstitutionService','InvestigationFormService','$stateParams','$timeout','$mdDialog','$rootScope'];
	function ReligiousInstitutionController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,ReligiousInstitutionService,InvestigationFormService,$stateParams,$timeout,$mdDialog,$rootScope) {
		
		var vm = this;
		vm.dateOfVisit = '';
		vm.app = APP;
		vm.now = new Date();
		$scope.interviewFlag = true;
		$scope.recordFlag = true;
		$scope.disablesaveflag = false;
		var oldFormData = {};
		
		vm.maxDate = new Date(
		   vm.now.getFullYear(),
		   vm.now.getMonth(),
		   vm.now.getDate()
		);
		
		$scope.religiousInstitution = {};
        $scope.religiousInstitution.sections = [];
        //$scope.religiousInstitution.sections.questions = [];
        $scope.religiousInstitution.summary = {};
        $scope.loadingReligious = false;

        vm.loadReligiousDetails = function(){
        	$scope.loadingReligious = true;
    		vm.getReligiousInformationDetails();
      	   
         };
         
         vm.getReligiousInformationDetails = function (){
			 $scope.entityObj.searchKey = null;
        	 var sectionKey = vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS;
    		   var formId = $scope.investigationFormId;
        	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
    		  	data.then(function(response){
    		  		if(response.formVersion != null){
     		  			$scope.formVersion = response.formVersion;
     		  		}
    		  		if(response.sectionId != null){
			  			$scope.religiousInsSectionId = response.sectionId;
			  		}
    		  		if(response.formDTO == null){
    		  		   var tempObj = {};
    		     	   tempObj.questions = [];
    		     	   $scope.religiousInstitution.sections.push(tempObj);
    		  		} else if(response.formDTO.sections.length == 0) {
  				  	   if(response.formDTO.summary){
						     var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.religiousInstitution.sections.push(tempObj);
				  	           $scope.religiousInstitution.summary = response.formDTO.summary;
				  	   } else {
						  	   var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.religiousInstitution.sections.push(tempObj);
				  	   }
		  	       } else {
    		  			$scope.religiousInstitution = response.formDTO;    		  			
		  		   }
    		  	   //Set the object to restrict the initial save call
		  		   oldFormData = angular.copy(response.formDTO);
    		  	   $scope.loadingReligious = false;
    		  	   $scope.updateLastEditTime(response.updatedOn);
    		   }, function(reason) {
    			  return reason;
    		   });
         };
         
         /* Method name            : saveReligiousInstitutionsDetails()
	      * Method Description 	   : This method saves the religious form details 
	 	  */ 
         $scope.saveReligiousInstitutionsDetails = function(){
        	   var isPutJsonSimilar = false;
        	   $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
        	   var saveDataObj = {};
        	   saveDataObj.formDTO = angular.copy($scope.religiousInstitution);
        	   saveDataObj.formVersion = $scope.formVersion;
        	   saveDataObj.investigationFormId =$scope.investigationFormId;
        	   saveDataObj.sectionId = $scope.religiousInsSectionId;
        	   for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
                   if(!saveDataObj.formDTO.sections[i].questions){
                       saveDataObj.formDTO.sections.splice(i,1);
                       i--;
                   } else if(saveDataObj.formDTO.sections[i].questions.length == 0) {
                       saveDataObj.formDTO.sections.splice(i,1);
                       i--;
                   } else {
                       delete saveDataObj.formDTO.sections[i].expanded;
                       saveDataObj.formDTO.sections[i].sortOrder = i+1;
                   }
               }
        	   
        	   /*	Set the temporary object to avoid unwanted save call. 
	      			Fist condition to avoid the initial save call for empty form 
	      			Second condition to avoid the initial save call if the section has any form data 
        	   */
               if(angular.isUndefined($scope.tempReligiousObj) && saveDataObj.formDTO.sections.length == 0 && oldFormData == null && 
                       (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined)) {
                   $scope.tempReligiousObj = angular.copy(saveDataObj);
               } else if(angular.isUndefined($scope.tempReligiousObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	   $scope.tempReligiousObj = angular.copy(saveDataObj);
               } else if(angular.isUndefined($scope.tempReligiousObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	   $scope.tempReligiousObj = {};
            	   $scope.tempReligiousObj.formDTO = angular.copy(oldFormData);
               }  
        	   
        	   if(!angular.isUndefined($scope.tempReligiousObj)){
	    		   if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempReligiousObj.formDTO))){
	    			   isPutJsonSimilar = true;	    			   
	    		   } 
	    	   }
        	   if($scope.isOwner){
        		   $scope.tempReligiousObj = angular.copy(saveDataObj);
        	   } else {
        		   $scope.tempReligiousObj = undefined; //Every time temporary object will be newly updated for non owner 
        	   }

        	   /* saveData flag - to ensure the save button is clicked in form*/
	       	   if(!isPutJsonSimilar){
		       		if($scope.isOwner || $scope.saveData){
		       			//Flag to set the section results are edited or not
		       			if(angular.isDefined($scope.religiousCheckList) && angular.isDefined($scope.religiousCheckListTempObj) && !angular.equals($scope.religiousCheckList, $scope.religiousCheckListTempObj)) {
		       				saveDataObj.isFormSectionResultEdited = true;
		       				$scope.saveAnalystFormTypeCheckList('religious', true, false);
		       			}
		       			
		       		 var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
		     		  	data.then(function(response){
			  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.RELEGIOUS_INSTUTE_STATE)
			  		  		{
			  		  			$scope.updateLastEditTime(response.updatedOn);
			  		  		}
			  		  		$scope.uploadFileStatusUpdated();
		     		  }, function(reason) {
		     			  return reason;
		     		  });
		       		}
		       	 $rootScope.warningPopup.show = true;
	       	   } else if($scope.isOwner || $scope.saveData && angular.isDefined($scope.religiousCheckList) && angular.isDefined($scope.religiousCheckListTempObj)
	       			   && !angular.equals($scope.religiousCheckList, $scope.religiousCheckListTempObj)) {
       				$scope.saveAnalystFormTypeCheckList('religious', true);
       			}
           };
           
           vm.interviewFlag = function(flag, index){
          	 $scope.interviewFlag = flag;
          	 if(index){
          		 $scope.sectionIndex = index; 
          	 }
            };
           
           vm.addAdditionalInterviewForm = function(){
               var testObj = {};
               if($scope.interviewFlag == 1){
              	 $scope.religiousInstitution.sections[0].questions[0].religiousInstitution_q2a.interviews.push(testObj);
               }
               if($scope.interviewFlag == 2){
              	 if($scope.sectionIndex){
              		 $scope.religiousInstitution.sections[$scope.sectionIndex].questions[0].religiousInstitution_q2a.interviews.push(testObj);
              	 }
               }
           };
            
            /* Method name           : collapseAll()
        	 * Method Description 	 : This method is used to collapse the accordion 
    		 */
        vm.collapseAll = function(index, flag) {
		var height = 0;
			for (var i = 0; i < $scope.religiousInstitution.sections.length; i++) {
				if (flag == 0) {
					height = height
							+ $('.acc_' + index).closest('.md-accordion').offsetHeight
						+ 42;
				} else {
					height = height
							+ $('.acc_' + index).closest('.md-accordion')[0].offsetHeight
							+ 42;
				}
				
				if (i == index) {
					if (!$scope.religiousInstitution.sections[i].expanded) {
						$scope.formViewCall(index);
						$scope.religiousInstitution.sections[i].expanded = !$scope.religiousInstitution.sections[i].expanded;
						$('#religiousInstitution').animate({
						scrollTop : height
						}, 'slow');
						// Calling get documents based on accordion index
						$scope.getUploadFiles(null,	vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS, index)
					} else {
						$scope.religiousInstitution.sections[i].expanded = !$scope.religiousInstitution.sections[i].expanded;
					}
				} else {
					$scope.religiousInstitution.sections[i].expanded = false;
				}
				if ($scope.religiousInstitution.sections[i].expanded) {
					if($scope.religiousInstitution.sections[i].questions[0] == undefined){
						$scope.notApproved=false;
					}else{
					$scope.isEntityApproved($scope.religiousInstitution.sections[i].questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId);
					}
					$scope.openAccordionIndex = i;
				}
			}
        };
           
           
           /* Method name           : addAdditionalInstitutionForm()
            * Method Description 	: This method adds Neighborhood canvas form to list of birth certificate form 
    	    */
           vm.addAdditionalInstitutionForm = function(){
               var tempObj = {};
               tempObj.questions = [];
               tempObj.expanded = false;
               $scope.notApproved=false;
               $scope.religiousInstitution.sections.push(tempObj);
               vm.collapseAll($scope.religiousInstitution.sections.length - 1,0);
           };
           
           
           /* Method name           : removeBirthCertificateForm()
            * Method Description 	: This method removes the added Neighborhood canvas form from list of birth certificate form
    	    */
           /*vm.removeReligiousInstitutions = function(index){
        	   $scope.religiousInstitution.sections.splice(index,1);
           };*/
           vm.removeReligiousInstitutions  = function(ev,id,indexValue){
        	   $scope.indexVal = indexValue;
        	   $mdDialog.show({
        		   contentElement: angular.element('#'+id),
        		   targetEvent: ev,
        		   clickOutsideToClose: false,
        		   escapeToClose: false
        	   })
           };
            
            vm.closeConform = function(index){
            	$scope.deleteLoader.flag = true;
            	$mdDialog.hide();
            	$scope.religiousInstitution.sections.splice(index,1);
            	if(index != 0){
               		vm.collapseAll(index-1,1);
               	}	
            	 $scope.enableDeleteButton();
            };
            
            vm.closeCancel = function(){
            	$mdDialog.cancel();
            	$scope.interviewFlag = true;
        		$scope.recordFlag = true;
            };
		vm.profileForm = $stateParams;
		

		 /* File Upload Sections */
       
       vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
   		$("#religiousInstitutionSectionSummary").val(null);
	        $('#religiousInstitutionSectionSummary').trigger('click'); 
	        $('#religiousInstitutionSectionSummary').off('change').on('change', function() {
	        	var file = this.files[0];
		   		var sectionId = $scope.religiousInsSectionId;
		   		var questionKey = null;
    			if(isSummary == "true"){
    				questionKey = vm.app.INVESTIGATION_FORM.SUMMARY_KEY;
    			}
    			$scope.setOrginSectionFileUpload(vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS);
    			$scope.uploadFileInSectionSummary(ev,file,questionKey,sectionId,isSummary,null,idName,accordionIndex,null);    			
	        });
		};

		vm.nextInvestigationForm = function(){
			$scope.disablesaveflag = true;
			$scope.saveAnalystFormTypeCheckList('religious');
			$scope.saveData = true;
			$scope.saveReligiousInstitutionsDetails();
			if($scope.investigationFormType == vm.app.INVESTIGATION.INVESTIGATOR_FORM){
				//$state.go("residencyQuestions");
				$rootScope.warningPopup.show = false;
	            $scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.RESIDENCY_FORM);
			}
			if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
				//$state.go("dnaInformation");
				//While clicking save button in religious section set warning popup false
				$rootScope.warningPopup.show = false;
	            $scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.DNA_FORM);
				$scope.collapseAll(5);
			}
			$scope.updateLastEditTime(null);
		};
		
		$rootScope.warningPopup.show = false;
		/* Method Description 	: This method triggers auto save for birth certificate form */
        $scope.$watch('religiousInstitutionAutoSave', function(newValue, oldValue) {
 			if(newValue != undefined && newValue != oldValue){ 				
 				if(newValue && $scope.isOwner){ 				
 	 					if($scope.formVersion && !$scope.isreadonly){
 	 						$scope.saveReligiousInstitutionsDetails();
 	 	 					$rootScope.religiousInstitutionAutoSave = false;
 						} else{
 							$rootScope.religiousInstitutionAutoSave = false;
 						}
 	 				}else{
 	 					$rootScope.religiousInstitutionAutoSave = false;
 	 				} 				
 			}
 		});
        
        /**
		 * To find which accordion is open currently
		 */	
		vm.findOpenform = function(){
        	 if($scope.religiousInstitution.sections.length > 1){
        		 var j = -1;
        		 for(var i = 0;i < $scope.religiousInstitution.sections.length;i++){
            		 if($scope.religiousInstitution.sections[i].expanded == true){
            			 return ++i;
            		 }
            	 } 
        		 return j;
        	 }
        	 return 1;
         };
			
		/**
		 * Add the requested Entity
		 * 
		 */	
         $rootScope.residencyEntityRequestsent = function(entity,locationObject,response){
	    	  var entityName = entity.entityName+", "+locationObject.cityObj.cityTxt+", "+locationObject.countryObj.countryTxt;
	    	  var openForm = vm.findOpenform();openForm--;
	    	  if(openForm != -1){
	    		  $scope.religiousInstitution.sections[openForm].questions[0].religiousInstitution_q1_yes_nameofInstitution.answer = entityName;
	    		  $scope.religiousInstitution.sections[openForm].questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId = response.id;
	    		  $scope.religiousInstitution.sections[openForm].questions[0].religiousInstitution_q1_yes_nameofInstitution.requested = true;
	    	  }
	    	  document.querySelector('.global-search-input input').value = entityName;
	    	  $scope.selectedtext = entityName;
		};
		
      //Method for add or suggest entity
	    vm.entityRequestSuggest = function(searchKey,entityName){
	    	return $scope.entityRequestAddorSuggest(searchKey,entityName);
	   	};
	   	
	    //It will get triggered while exiting from current state
	   	$scope.$on('$destroy', function() {
	   		if(!$scope.isreadonly && $scope.isOwner) {
	   			$scope.saveReligiousInstitutionsDetails();
        	}
	   		$rootScope.warningPopup.show = false;
	   		$scope.uploadedFile = false;
        });

	   	//To open the confirmation pop up for remove the additional interview or records
    	vm.deleteIndex = function(event,id,index,isInterview){
			$scope.indexVal = index;
			$scope.isInterview = isInterview;
			$scope.interviewFlag = false;
			$scope.recordFlag = false;
			$mdDialog.show({
				contentElement: angular.element('#'+id),
				targetEvent: event,
				clickOutsideToClose: false,
				escapeToClose: false,
				onRemoving: function (event, removePromise) {
					vm.closeCancel();
				}
			});
    	};
       	
    	//To remove the interview content form the form data
       	vm.deleteInterviewConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		if($scope.religiousInstitution.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.religiousInstitution.sections[$scope.openAccordionIndex].questions[0].religiousInstitution_q2a.interviews.splice(index,1);
       	    vm.closeCancel();
       	    $scope.enableDeleteButton();
       	};
       	
       	//To remove the records form the form data
       	vm.deleteRecordConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		if($scope.religiousInstitution.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.religiousInstitution.sections[$scope.openAccordionIndex].questions[0].religious_record_list.records.splice(index,1);
       	    vm.closeCancel();
       	 $scope.enableDeleteButton();
       	};
	}
})();